var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"share-link",attrs:{"href":_vm.href,"rel":"noopener noreferrer"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.onClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }